/* eslint-disable no-unused-vars */
enum UserGender {
  MALE = 'male',
  FEMALE = 'female',
  UNDECLARED = 'undeclared',
}

enum StepType {
  INTRO = 'intro',
  BUILDING = 'building',
  CIRCUIT = 'circuit',
  CODING = 'coding',
  BEHIND = 'behind-the-code',
  SIMULATOR = 'simulator',
  LEARN = 'what-did-you-learn',
  TEACHER = 'material-teacher',
  SETUP = 'setup',
  VIDEO = 'video',
}

enum ResourceType {
  MARKDOWN = 'markdown',
  CODING = 'coding',
  MAKECODE = 'tutorial_microbit',
  EMBEDING = 'embeding',
  NONE = 'none',
  SLIDE = 'slide',
  VIDEO = 'video',
}

enum UserRole {
  ADMIN = 'admin',
  MANAGER = 'manager',
  EDITOR = 'editor',
  TEACHER = 'teacher',
  STUDENT = 'student',
  GHOST = 'ghost',
}

enum UserStatus {
  ACTIVE = 'active',
  DISABLED = 'disabled',
  PENDING = 'pending',
}

enum SkillLevels {
  LEARNER = 'learner',
  PRO = 'pro',
  MASTER = 'master',
}

enum CategorySlugs {
  INTRODUCTORY = 'introductory',
  BNCC = 'bncc',
  STEAM = 'steam',
  COMMUNITY = 'community',
}

enum ActivityStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
  COMPLETED = 'completed',
  ARCHIVED = 'archived',
}

enum SolutionStatus {
  DELIVERED = 'delivered',
  APPROVED = 'approved',
  CONTESTED = 'contested',
}

enum TutorialStatus {
  NOSTARTED = 'no_started',
  PROGRESS = 'progress',
  COMPLETED = 'completed',
}

enum BitName {
  POWER = 'Power',
  BUTTON = 'Button',
  ROLLERSWITCH = 'RollerSwitch',
  LIGHTSENSOR = 'LightSensor',
  DIMMER = 'Dimmer',
  SOUNDSENSOR = 'SoundSensor',
  WIRE = 'Wire',
  BRIGHTLED = 'BrightLED',
  BUZZER = 'Buzzer',
  BARGRAPH = 'Bargraph',
  DCMOTOR = 'DCMotor',
}

enum BitCategory {
  POWER = 'Power',
  OUTPUT = 'Output',
  INPUT = 'Input',
  CONNECTION = 'Connection',
}

enum Skills {
  CATEGORY = 'bits_categories',
  FUNCTIONALITY = 'bits_functionalities',
  CONDITIONAL = 'conditional_logic',
  SEQUENTIAL = 'sequential_logic',
  VARIABLES = 'variables_identification',
  CIRCUIT = 'circuit_creation',
}

enum TypeProjects {
  PROJECT = 'fundamental 1',
  TUTORIAL = 'fundamental 2',
}

enum HardwareSlug {
  MICROBIT = 'micro_bit',
  FUZZYBITS = 'fuzzy_bits',
  SMARTMAKERS_1 = 'smart_makers_1',
  SMARTMAKERS_2 = 'smart_makers_2',
  MAKEYMAKEY = 'makey_makey',
  FUZZYBOT = 'fuzzy_bot',
  FUZZYPLUS = 'fuzzy_bits_plus',
  SCRATCH = 'scratch',
}

enum Grades {
  ANO1 = 'ANO-1',
  ANO2 = 'ANO-2',
  ANO3 = 'ANO-3',
  ANO4 = 'ANO-4',
  ANO5 = 'ANO-5',
  ANO6 = 'ANO-6',
  ANO7 = 'ANO-7',
  ANO8 = 'ANO-8',
  ANO9 = 'ANO-9',
  ANO10 = 'ANO-10',
}

enum SortType {
  RECENT = 'recent',
  RELEVANT = 'relevant',
  MOST_COMMENTED = 'most_commented',
  KEYWORDS = 'keyword',
}

const statusTexts = {
  [UserStatus.ACTIVE]: 'Ativo',
  [UserStatus.DISABLED]: 'Desativado',
  [UserStatus.PENDING]: 'Cadastro pendente',
};

const genderTexts = {
  [UserGender.MALE]: 'Masculino',
  [UserGender.FEMALE]: 'Feminino',
  [UserGender.UNDECLARED]: 'Não declarado',
};

const skillLevelsTexts = {
  [SkillLevels.LEARNER]: 'Aprendiz',
  [SkillLevels.PRO]: 'PRO',
  [SkillLevels.MASTER]: 'Mestre',
};

const activityStatusTexts = {
  [ActivityStatus.DRAFT]: 'Rascunho',
  [ActivityStatus.PUBLISHED]: 'Publicado',
  [ActivityStatus.COMPLETED]: 'Finalizado',
  [ActivityStatus.ARCHIVED]: 'Arquivado',
};

const solutionStatusTexts = {
  [SolutionStatus.APPROVED]: 'Aprovada',
  [SolutionStatus.CONTESTED]: 'Contestada',
  [SolutionStatus.DELIVERED]: 'Entregue',
};

const skillsTexts = {
  [Skills.CATEGORY]: 'Categorias dos Bits',
  [Skills.FUNCTIONALITY]: 'Funções dos Bits',
  [Skills.CONDITIONAL]: 'Lógica Condicional',
  [Skills.SEQUENTIAL]: 'Lógica Sequencial',
  [Skills.VARIABLES]: 'Identificação de Variáveis',
  [Skills.CIRCUIT]: 'Criação de Circuits',
};

const gradeTexts = {
  [Grades.ANO1]: '1º Ano - Ensino Fundamental I',
  [Grades.ANO2]: '2º Ano - Ensino Fundamental I',
  [Grades.ANO3]: '3º Ano - Ensino Fundamental I',
  [Grades.ANO4]: '4º Ano - Ensino Fundamental I',
  [Grades.ANO5]: '5º Ano - Ensino Fundamental I',
  [Grades.ANO6]: '6º Ano - Ensino Fundamental II',
  [Grades.ANO7]: '7º Ano - Ensino Fundamental II',
  [Grades.ANO8]: '8º Ano - Ensino Fundamental II',
  [Grades.ANO9]: '9º Ano - Ensino Fundamental II',
  [Grades.ANO10]: 'ano de escolaridade acima',
};

const hardwareTexts = {
  [HardwareSlug.FUZZYBITS]: 'Fuzzy Start',
  [HardwareSlug.FUZZYPLUS]: 'Fuzzy Plus',
  [HardwareSlug.FUZZYBOT]: 'Fuzzy BoT',
  [HardwareSlug.SMARTMAKERS_1]: 'Smart¹',
  [HardwareSlug.SMARTMAKERS_2]: 'Smart²',
  [HardwareSlug.MAKEYMAKEY]: 'Makey Makey',
  [HardwareSlug.MICROBIT]: 'Micro:Bit',
  [HardwareSlug.SCRATCH]: 'Scratch',
};

const filterToSortTypeTexts = {
  [SortType.RECENT]: 'Recentes',
  [SortType.RELEVANT]: 'Populares',
  [SortType.MOST_COMMENTED]: 'Comentados',
  [SortType.KEYWORDS]: 'Palavra chave',
};

enum VerificationStatusRequirements {
  PENDING = 'pending',
  VERIFIED = 'verified',
  FAILED = 'failed',
}

const ResourceTypeDisplayNames: { [key in ResourceType]: string } = {
  [ResourceType.MARKDOWN]: 'Texto Markdown',
  [ResourceType.MAKECODE]: 'Tutorial MakeCode',
  [ResourceType.SLIDE]: 'Apresentação de Slides',
  [ResourceType.VIDEO]: 'Vídeo',
  [ResourceType.EMBEDING]: 'Conteúdo Embed',
  [ResourceType.CODING]: 'Atividade de Código',
  [ResourceType.NONE]: 'Nenhum',
};

const StepTypeDisplayNames: { [key in StepType]: string } = {
  [StepType.INTRO]: 'Introdução',
  [StepType.BUILDING]: 'Montagem',
  [StepType.CIRCUIT]: 'Construção',
  [StepType.CODING]: 'Programação',
  [StepType.SIMULATOR]: 'Simulador',
  [StepType.TEACHER]: 'Para o professor',
  [StepType.LEARN]: 'O que você aprendeu',
  [StepType.BEHIND]: 'Por trás do código',
  [StepType.SETUP]: 'Configuração',
  [StepType.VIDEO]: 'Vídeo',
};

export {
  UserGender,
  UserRole,
  StepType,
  ResourceType,
  UserStatus,
  SkillLevels,
  CategorySlugs,
  ActivityStatus,
  SolutionStatus,
  BitName,
  TutorialStatus,
  BitCategory,
  Skills,
  TypeProjects,
  HardwareSlug,
  Grades,
  SortType,
  statusTexts,
  genderTexts,
  skillLevelsTexts,
  activityStatusTexts,
  solutionStatusTexts,
  skillsTexts,
  gradeTexts,
  hardwareTexts,
  filterToSortTypeTexts,
  VerificationStatusRequirements,
  ResourceTypeDisplayNames,
  StepTypeDisplayNames,
};
